var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_531_2310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5013 15.5837C4.58918 15.5837 1.41797 12.4125 1.41797 8.50033C1.41797 4.5882 4.58918 1.41699 8.5013 1.41699C12.4134 1.41699 15.5846 4.5882 15.5846 8.50033C15.5846 12.4125 12.4134 15.5837 8.5013 15.5837ZM8.5013 14.167C10.0042 14.167 11.4455 13.57 12.5082 12.5073C13.5709 11.4446 14.168 10.0032 14.168 8.50033C14.168 6.99743 13.5709 5.55609 12.5082 4.49339C11.4455 3.43068 10.0042 2.83366 8.5013 2.83366C6.99841 2.83366 5.55707 3.43068 4.49436 4.49339C3.43166 5.55609 2.83464 6.99743 2.83464 8.50033C2.83464 10.0032 3.43166 11.4446 4.49436 12.5073C5.55707 13.57 6.99841 14.167 8.5013 14.167ZM9.20964 8.50033H12.043V9.91699H7.79297V4.95866H9.20964V8.50033Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_531_2310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeLine);
export default __webpack_public_path__ + "static/media/time-line.98fa84a187d2e8afd584a76ad08b9e67.svg";
export { ForwardRef as ReactComponent };